import React from "react";

const SearchPage = () => {
  return <div>This is a search Page</div>;
};

export default SearchPage;
